import { useRecords } from "../hooks/useRecords.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Records/shared/RecordTitles.tsx
var RecordTitles = ({ listAll = true, recordIds }) => {
	const { data, loading } = useRecords({ idFilter: recordIds }, { cacheStrategy: "cache-only" });
	if (!data?.records && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.records || !recordIds?.length) return null;
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: data.records[0].title
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.records.map(({ title }) => title).join(", ") });
};
//#endregion
export { RecordTitles };

//# sourceMappingURL=RecordTitles.js.map